export const showBannerMessage = process.env.REACT_APP_SHOW_BANNER_MESSAGE || ''
export const showRewards = true
